function ProgressIndicator(el) {
    this.el = el;

    this.updateProgress();
    window.addEventListener('scroll', _ => this.updateProgress());
}

ProgressIndicator.prototype.updateProgress = function() {
    let percentage = window.scrollY / (document.body.offsetHeight - window.innerHeight) * 100;

    if (percentage > 100) percentage = 100;
    else if (percentage < 0) percentage = 0;

    gsap.to(this.el, 0.3, { width: percentage + '%', ease: Power2.easeOut });
};

(function() {
    const progressIndicatorEl = document.querySelector('.jsProgressIndicator');
    if (progressIndicatorEl) new ProgressIndicator(progressIndicatorEl);
})();
